module.exports = require("./yi.d.ts");